import { render, staticRenderFns } from "./Personalnav.vue?vue&type=template&id=66093839&scoped=true&"
import script from "./Personalnav.vue?vue&type=script&lang=js&"
export * from "./Personalnav.vue?vue&type=script&lang=js&"
import style0 from "./Personalnav.vue?vue&type=style&index=0&id=66093839&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66093839",
  null
  
)

export default component.exports